import React, {useCallback, useEffect, useRef, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  SIDEBAR_CABINET_BUTTONS,
  SIDEBAR_BUTTONS_MENU,
  CABINET_SET2,
  SQFT_VIEW_MODE
} from "../../constants";
import {
  setSQFTActiveButton,
  setSQFTActiveLevel3Button,
  setSQFTMenuOpened,
  setSQFTMenuOpenedLock
} from "../../../../actions/sqftMenuFunctions";
import {useOutsideClick} from "../../../../misc/helperHooks";
import config from "../canvas/store/sqftConfig";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";
import sqftEventManager from "../canvas/store/sqftEventManager";
import {setSqftCabinetsGlb} from "../../../../actions/sqftFunctions";
import cabinetWorkspace from "../canvas/core/cabinet/cabinetWorkspace";

const SqftNavAsideCabinet = (props) => {
  const { menuOpened, menuOpenedLock, activeButton, SQFTViewMode } = props;
  const { setSQFTMenuOpened, setSQFTMenuOpenedLock, setSQFTActiveButton, setSQFTActiveLevel3Button } = props;

  const dropdownElement = useRef(null);
  const [sideBarButtons, setSideBarButtons] = useState(SIDEBAR_CABINET_BUTTONS);

  useOutsideClick(dropdownElement, (event) => {
    const disallowClasses = [".sidebar", ".sidebar2", ".side", ".expanded", ".full-screen-wrapper", ".side-level2",
      ".side-level3", ".MuiSvgIcon-root"];

    const isClickInsideDisallowedClass = disallowClasses.some(cls => event.target.closest(cls) !== null);

    if (!isClickInsideDisallowedClass) {
      if (menuOpenedLock) {
        setSQFTMenuOpenedLock(false);
      } else {
        if (menuOpened !== "") {
          setSQFTMenuOpened("");
          setSQFTActiveLevel3Button(null);
        }
      }
    }

  }, true);

  const handleButtonClick = (button) => {
    if (SQFTViewMode !== SQFT_VIEW_MODE.twoDMode) {
      return
    }
    clearAllMenusEvents();
    let newMenuButton = button.menu

    //close if already opened
    if (activeButton === newMenuButton && SIDEBAR_BUTTONS_MENU.delete === newMenuButton) {
      newMenuButton = SIDEBAR_BUTTONS_MENU.move
    }
    setSQFTActiveButton(newMenuButton);
    config.workspace.menuItemActive = newMenuButton;

    //open submenu
    if (button.hasMenu) {
      const newMenu = menuOpened === newMenuButton
        ? "" // same button click
        : newMenuButton;
      setSQFTMenuOpened(newMenu);
    }

    //additional events on click
    if (newMenuButton === SIDEBAR_BUTTONS_MENU.delete) {
      sqftEventManager.setCursor("delete", this, true);
    }

    //additional events on click
    if (newMenuButton === SIDEBAR_BUTTONS_MENU.cabinetset) {
      void CABINET_SET2;
      cabinetWorkspace.cabinetShapesLayout.createShapesFromCabinetSet(CABINET_SET2);
    }
  };

  const getSubMenuActiveButton = useCallback((sidebarButton, activeButton) => {
    let subMenuActiveButton = null
    if (sidebarButton.subMenu) {
      subMenuActiveButton = Object.keys(sidebarButton.subMenu).find(submenuButton => submenuButton === activeButton)
    }

    return subMenuActiveButton
  }, []);

  const setNavigationDisplayButton = useCallback((activeButton) => {
    const preparedSidebarButtons = [];
    SIDEBAR_CABINET_BUTTONS.forEach((sidebarButton) => {
      const subMenuActiveButton = getSubMenuActiveButton(sidebarButton, activeButton);
      const preparedButton = {...sidebarButton};
      if (subMenuActiveButton) {
        preparedButton.buttonToDisplay = activeButton
        preparedButton.message = "sqft.navigation.submenu." + activeButton
      }
      preparedSidebarButtons.push(preparedButton);
    })
    setSideBarButtons(preparedSidebarButtons)
  }, [getSubMenuActiveButton]);

  useEffect(() => {
    setNavigationDisplayButton(activeButton);
  }, [activeButton, getSubMenuActiveButton, setNavigationDisplayButton])

  useEffect(() => {
    setSQFTActiveButton("");
  }, [setSQFTActiveButton])

  return (
    <aside className="sidebar" ref={dropdownElement}>
      <div className="sidebar-buttons">
        <div className="sidebar-buttons--top">
          {sideBarButtons.map((item, index) => {
            const isActive = activeButton === (item.buttonToDisplay ? item.buttonToDisplay : item.menu);
            const classNames = "button "
              + "button--" + (item.buttonToDisplay ? item.buttonToDisplay : item.menu)
              + (item.hasMenu ? " button--parent" : "")
              + (isActive ? " button--active" : "");
            return (
              <button key={index}
                      className={classNames}
                      onClick={() => handleButtonClick(item)}
                      title={item.title}>
                <span className="button-text">
                  <FormattedMessage id={item.message}/>
                </span>
                <span className={item.additionalClassNames}/>
              </button>
            )
          })}
        </div>
        <div className="sidebar-buttons--bottom-mobile">
          <div className="sidebar-separator hide-mobile"/>
        </div>
      </div>
    </aside>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  menuOpenedLock: store.sqftMenuState.menuOpenedLock,
  activeButton: store.sqftMenuState.activeButton,
  fabricatorData: store.fabricatorState,
  isMobile: store.serverState.isMobile,
  cabinetsGlb: store.sqftState.cabinetsGlb,
  SQFTViewMode: store.sqftState.SQFTViewMode,
});

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTMenuOpenedLock,
  setSQFTActiveButton,
  setSqftCabinetsGlb,
  setSQFTActiveLevel3Button,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAsideCabinet);
